<template>
  <div>
    <v-layout v-if="loading" justify-center column fill-height style="min-height: 300px">
      <div class="spinner text-xs-center" style="top:100px">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </v-layout>
    <template v-else>
      <v-container>
        <v-layout>
          <v-flex>
            <h1>
              {{ $t('Comment to Inbox') }}
              <a
                href="https://blog.zwiz.ai/%e0%b8%81%e0%b8%b2%e0%b8%a3%e0%b8%95%e0%b8%ad%e0%b8%9a%e0%b8%81%e0%b8%a5%e0%b8%b1%e0%b8%9a%e0%b8%84%e0%b8%ad%e0%b8%a1%e0%b9%80%e0%b8%a1%e0%b8%99%e0%b8%95%e0%b9%8c/"
                target="blank"
                ><i style="font-size: 18px; color: #ed1e79;" class="fas fa-question-circle"></i
              ></a>
            </h1>
          </v-flex>
          <v-flex class="text-xs-right">
            <transfer-intent
              type="replycomment"
              :total_count="total_count"
              :all_count="all_count"
              :intents="intents"
            ></transfer-intent>
          </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex xs12 sm6 class="form-control search" style="display: inherit;">
            <div class="input-icons">
              <i class="fa fa-search icon"></i>
              <input
                @keyup.enter="
                  pageNumber = 1
                  getIntent()
                "
                type="text"
                v-model="search"
                class="form-control"
                :placeholder="$t('Search Comment to inbox')"
                style="margin-bottom: 10px"
              />
              <v-btn v-show="search.length > 0" @click="clearSearch" icon class="icon-close">
                <i class="fa fa-close"></i
              ></v-btn>
            </div>
            <multiselect
              class="ma-0 mb-1 mr-1 ml-1"
              style="max-width: 100px"
              v-model="statusStatus"
              :close-on-select="true"
              :show-labels="false"
              :options="statusOptions"
              label="label"
              selectLabel
              selectedLabel
              :allow-empty="false"
              :searchable="false"
              deselect-label
              track-by="label"
              @select="onSelectStatus"
            >
            </multiselect>
            <v-btn
              @click="
                pageNumber = 1
                getIntent()
              "
              color="primary"
            >
              {{ $t('Search') }}
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right">
            <v-btn outline color="primary" @click="expandAll">
              <i class="fas fa-expand-arrows-alt mr-1"></i>
              {{ $t('Expand All') }}
            </v-btn>
            <v-btn outline color="primary" @click="collapseAll">
              <i class="fas fa-compress mr-1"></i>
              {{ $t('Collapse All') }}
            </v-btn>
          </v-flex>
        </v-layout>

        <div>
          <div style="margin-bottom: 10px;">
            <a href="javascript:void(0);" v-if="!isShow" @click="addCommentToInbox">
              <div class="add-conversation text-xs-center">
                <i class="fa fa-plus middle"></i>
                {{ $t('Add Comment to inbox') }}
              </div>
            </a>

            <div class="intent-item z-border-red" v-else style="padding: 10px 15px 0px;">
              <manage-intent
                :isCommentToInbox="true"
                :type="'add'"
                v-model="intent"
                @close="onClose"
                @saveIntent="onSaveIntent"
                :excludedIntentName="excludedIntentName"
                :hasTypeDateAndTime="true"
              ></manage-intent>
            </div>
          </div>

          <v-layout wrap v-if="!$store.state.centralPage.includes(selectedBot.pageid)">
            <v-flex xs12 sm3 style="align-self: center; margin-top: 15px;">
              <v-checkbox
                v-if="!loadingIntent"
                id="cbAll"
                :label="$t('Check all')"
                style="display: inline-block; margin: 0"
                v-model="checkboxAll"
                @change="clickCbAll"
                color="primary"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12 sm9>
              <div class="text-xs-right mt-3">
                <v-btn class="ma-0 mb-1 mr-1" @click="deleteSelected" color="primary" outline>
                  <i class="fas fa-trash mr-1"></i>
                  {{ $t('delete_comment_selected') }}
                </v-btn>
                <v-btn class="ma-0 mb-1 mr-1" @click="showDialog = true" color="primary" outline>
                  <i class="fas fa-trash mr-1"></i>
                  {{ $t('delete_all') }}
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
          <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
            <v-pagination
              :total-visible="showsize"
              v-model="pageNumber"
              :length="pageCount"
              @input="
                getIntent()
                checkboxAll = false
              "
            ></v-pagination>
          </div>
          <!-- <transition-group
            v-bind:css="false"
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
            v-on:leave="leave"
          > -->
          <v-layout
            v-if="loadingIntent"
            justify-center
            column
            fill-height
            style="min-height: 500px"
            class="text-xs-center"
          >
            <div class="spinner text-xs-center">
              <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
            </div>
          </v-layout>

          <intent-item
            v-for="(item, index) in paginateIntent"
            @assignCb="assignCb"
            :cbAll.sync="cbAll"
            :pageNumber="pageNumber"
            v-model="paginateIntent[index]"
            :filterIntents="paginateIntent"
            :isCommentToInbox="true"
            :key="'intent_' + item.id + '_' + index"
            :indexIntent="index"
            @onDelete="deleteIntent(index)"
            @onCopyIntent="copyIntent"
            :excludedIntentName="excludedIntentName"
            @onUpdate="onUpdateIntent"
            :isComment="true"
          ></intent-item>

          <!-- </transition-group> -->
          <div v-if="showPagination" class="mt-2 mb-2 text-xs-right">
            <v-pagination
              :total-visible="showsize"
              v-model="pageNumber"
              :length="pageCount"
              @input="
                getIntent()
                checkboxAll = false
              "
            ></v-pagination>
          </div>
        </div>
      </v-container>
      <v-divider></v-divider>

      <div style="position: relative">
        <v-container>
          <v-premium-plan-popup
            :showAll="false"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
            text="You don't have to set keywords. It was able to collect all comments! Starting at 500 baht/month. Upgrade now!"
          ></v-premium-plan-popup>
          <h2>{{ $t('More Comment to Inbox') }}</h2>
          <transition name="fade">
            <div class="col s12" v-if="default_comment_to_inbox">
              <intent-item
                :isCommentToInbox="true"
                v-model="default_comment_to_inbox"
                :isDefault="true"
                @onDelete="deleteIntent(index)"
                :excludedIntentName="excludedIntentName"
                @onUpdate="onUpdateIntent"
              ></intent-item>
            </div>
          </transition>
        </v-container>
      </div>
      <div class="mt-5 mb-5"></div>
    </template>
    <v-dialog v-model="showDialog" max-width="500px">
      <v-card v-if="showDialog">
        <div style="position: absolute; right: 0px;">
          <v-btn fab small flat @click="showDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div class="text-xs-center">
            <i class="fas fa-info-circle mb-3" style="font-size: 50px; color:#ed1e78"></i>
          </div>
          <div class="text-xs-center" style="background: #ffe1ee; padding: 35px;">
            <div class="mb-1">{{ $t('confirm_delete') }}</div>
            <div class="form-control left-align" :class="{ 'has-error': errors.has('username') }">
              <input
                type="text"
                class="input form-control"
                aria-describedby="userid"
                :placeholder="$t('type_to_confirm_delete')"
                v-model="confirmDelete"
                v-validate="'required'"
                data-vv-as="Username"
                data-vv-name="username"
              />
            </div>
          </div>
          <div class="text-xs-center mt-2">
            <v-btn outline color="primary" class="" @click="showDialog = false">
              {{ $t('cancel') }}
            </v-btn>

            <v-btn depressed color="primary" @click="saveDeleteAll">
              {{ $t('Save') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import TransferIntent from './TransferIntent'
import { mapGetters } from 'vuex'
import manageIntent from './intent-manage'
import intentItem from './intent-item'
import api from '@/api'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalHelp from '@/components/elements/ModalHelp'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    'manage-intent': manageIntent,
    'intent-item': intentItem,
    ModalDialog,
    ModalHelp,
    TransferIntent,
    Multiselect
  },
  data() {
    return {
      cbAll: [],
      checkboxAll: false,
      confirmDelete: '',
      showDialog: false,
      statusOptions: [
        {
          label: this.$t('All'),
          value: ''
        },
        {
          label: this.$t('Active'),
          value: 'true'
        },
        {
          label: this.$t('Inactive'),
          value: 'false'
        }
      ],
      statusStatus: {
        label: this.$t('All'),
        value: ''
      },
      total_count: 0,
      loading: false,
      loadingIntent: false,
      isShow: false,
      showModal: false,
      showPagination: false,
      pageNumber: 1,
      pageCount: 0,
      showsize: 15,

      intent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '',
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        linenoti_spec_ids: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
        time_setting: {
          Monday: { status: true, openat: null, closeat: null },
          Tuesday: { status: true, openat: null, closeat: null },
          Wednesday: { status: true, openat: null, closeat: null },
          Thursday: { status: true, openat: null, closeat: null },
          Friday: { status: true, openat: null, closeat: null },
          Saturday: { status: true, openat: null, closeat: null },
          Sunday: { status: true, openat: null, closeat: null }
        }
      },
      allIntents: [],
      intents: [],
      search: '',
      welcome_message: {
        message: '',
        generics: [],
        type: '',
        quick_reply: []
      },
      isSave: false,
      lastedIntentName: '',
      default_comment_to_inbox: undefined,
      max_intent: 300,
      all_count: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),

    paginateIntent() {
      if (this.filterIntents.length >= 100) {
        this.showPagination = true
        var start = (this.pageNumber - 1) * this.showsize
        var end = this.pageNumber * this.showsize
        var result = this.filterIntents.slice(start, end)
        return result
      } else {
        this.showPagination = true
        return this.filterIntents
      }
    },
    // pageCount: function() {
    //   let l = this.filterIntents.length
    //   let s = this.showsize
    //   return Math.ceil(l / s)
    // },
    filterIntents: function() {
      const vm = this
      vm.intents.sort(function(a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
          return 1
        }
        if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      return vm.intents
    },
    excludedIntentName: function() {
      var result = []
      var vm = this
      if (vm.allIntents) {
        vm.allIntents.map(function(intent, index) {
          result.push(intent.intentname)
        })
      }
      return result.join(',')
    },
    totalIntentWithoutDefault() {
      var intentwithoutwelcome = this.intents.filter(el => {
        return !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
          el.intentname
        )
      })
      return intentwithoutwelcome.length
    }
  },
  mounted: function() {
    var vm = this
    if (this.selectedBot.pageid == '176922345693076') {
      this.max_intent = 500
    }

    let package_config = this.getPackageConfig()
    this.max_intent = package_config.reply_comment

    if (this.selectedBot.pageid == '1667559336833768') {
      this.max_intent = 500
    }

    vm.loading = true
    vm.getWelcomeMessage(function() {
      vm.getIntent(function() {
        vm.getDefaultIntent()
        vm.loading = false
      })
    })
    if (vm.selectedBot.theme == 'ecommercebasic') {
      vm.$store.dispatch('loadCategory').then(function() {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting')
  },
  methods: {
    async deleteSelected() {
      const vm = this
      const result = await vm.$swal.fire({
        title: vm.$t('confirm_delete_comment'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })

      if (result.value) {
        vm.$store.dispatch('loading')
        let res = await vm.delete(
          `intents?ids=${vm.cbAll.toString()}&pageid=${vm.selectedBot.pageid}`
        )
        if (res.responsecode === 200) {
          vm.$swal.fire({
            title: vm.$t('Successfully'),
            text: ``,
            type: 'success'
          })
          vm.cbAll = []
          vm.getIntent()
        }
        vm.$store.dispatch('loading')
      }
    },
    assignCb(id) {
      if (this.cbAll.includes(id)) this.cbAll = this.cbAll.filter(v => id != v)
      else {
        this.cbAll.push(id)
      }
    },
    clickCbAll() {
      if (this.checkboxAll) {
        this.paginateIntent.map(v => {
          this.cbAll.push(v.id)
        })
        this.checkboxAll = true
      } else {
        this.cbAll = this.cbAll.filter(elem => {
          return !this.paginateIntent.some(ele => {
            return ele.id === elem
          })
        })
        this.checkboxAll = false
      }
    },
    async saveDeleteAll() {
      const vm = this
      let result = await vm.$validator.validateAll()
      if (result) {
        if (vm.confirmDelete === 'confirm') {
          vm.$store.dispatch('loading')
          let res = await vm.delete(`page/${vm.selectedBot.pageid}/delete-all-comment-intent`)
          if (res.success) {
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: ``,
              type: 'success'
            })
            vm.confirmDelete = ''
            vm.showDialog = false
            vm.getIntent()
          }
          vm.$store.dispatch('loading')
        }
      }
    },
    beforeEnter: function(el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function(el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function() {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    },
    onSaveIntent: function(payload) {
      // console.log(JSON.parse(payload.a_val))
      var vm = this
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      vm.isShow = false
      payload.isShow = true
      vm.intents.push(payload)
      vm.allIntents.push(payload)
      vm.intent = {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: [[]],
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        linenoti_spec_ids: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      }
      vm.lastedIntentName = payload.intentname
      vm.isSave = true
      vm.onClose()
      vm.isSave = false
      vm.$swal.fire({
        title:
          vm.$t('conversation') +
          ' "' +
          payload.intentname.replace(/\<|\>/g, '') +
          '" ' +
          vm.$t('added'),
        type: 'success',
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
    },
    copyIntent: function(payload) {
      if (this.$store.getters.getPackage != 'premium' && this.all_count >= 2) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'reply_comment_you_have_reached_the_limit_for_the_package'
            )}${this.$t('upgrade_to_advanced_now')}</b>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then(result => {
            if (result.value) {
              this.$router.push('Upgrade').catch(() => {})
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.all_count >= this.max_intent &&
        !this.$store.state.UnlimitedConversation.includes(this.selectedBot.pageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'reply_comment_you_have_reached_the_limit_for_the_package'
            )}${this.$t('please_contact_us')}</b>`,
            confirmButtonText: this.$t('contact_us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then(result => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        payload.onCopy().then(result => {
          result.isShow = true
          this.intents.push(result)
          this.allIntents.push(result)
          var vm = this
          vm.$swal.fire({
            title:
              vm.$t('conversation') +
              ' "' +
              result.intentname.replace(/\<|\>/g, '') +
              '" ' +
              vm.$t('added'),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        })
      }
    },
    onClose: function(payload) {
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      this.isShow = false
    },
    onSelectStatus(param) {
      const vm = this
      vm.statusStatus = param
      // vm.getIntent()
    },
    getIntent: function(callback) {
      let vm = this
      vm.loadingIntent = true
      let data = {
        pageid: vm.selectedBot.pageid,
        limit: vm.showsize,
        offset: (vm.pageNumber - 1) * vm.showsize,
        page_intent: 'comment',
        search_intent: vm.search || '',
        sort_by: 'intentname',
        sort_type: 'asc',
        intent_status: vm.statusStatus && vm.statusStatus.value ? vm.statusStatus.value : ''
      }
      api.getIntent(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          vm.pageCount = Math.ceil(response.total_count / vm.showsize)
          var intents = response.data.map(function(val) {
            var intent = { ...val }
            intent.isShow = false
            intent.ableToDelete = true
            return intent
          })
          vm.all_count = response.all_count
          vm.total_count = response.total_count
          vm.allIntents = intents
          vm.intents = intents.filter(el => {
            return (
              el.context_in == 'comment' &&
              el.intentname != '{default_comment_to_inbox}' &&
              el.intentname != '{welcome}'
            )
          })
          vm.checkboxAll = vm.intents.every(o => vm.cbAll.some(v => v === o.id))
        }
        vm.loadingIntent = false
        callback()
      })
    },
    getDefaultIntent() {
      let vm = this
      vm.loadingIntent = true
      let data = {
        pageid: vm.selectedBot.pageid,
        page_intent: 'comment',
        intent_name: '{default_comment_to_inbox}'
      }
      return new Promise((resolve, reject) => {
        api.getIntent(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            const default_comment_to_inbox = response.data.find(el => {
              return el.intentname == '{default_comment_to_inbox}'
            })

            if (default_comment_to_inbox) {
              default_comment_to_inbox.ableToDelete = false
              default_comment_to_inbox.isShow = false
              vm.default_comment_to_inbox = default_comment_to_inbox
            } else {
              vm.default_comment_to_inbox = {
                intentname: '{default_comment_to_inbox}',
                q_type: 'text',
                a_type: 'json',
                q_val: '{default}',
                a_val: [[]],
                context_in: '',
                context_out: '',
                ableToDelete: false,
                isShow: false,
                pageidlist: '',
                userstatus: '',
                usertags: '',
                linenoti_status: false,
                linenoti_spec_ids: null,
                linenoti_text: null,
                starttime: null,
                endtime: null,
                intentstatus: true
              }
            }
          }
          vm.loadingIntent = false
          resolve()
        })
      })
    },
    deleteIntent: function(index) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.paginateIntent[index].intentname.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let data = {
              id: vm.paginateIntent[index].id,
              pageid: vm.selectedBot.pageid
            }
            vm.$store.dispatch('loading')
            api.deleteIntent(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }
              vm.$swal.fire({
                title: vm.$t('Successfully'),
                text: vm.$t('conversation_has_been_deleted'),
                type: 'success'
              })
              $.each(vm.intents, function(intent_index, intent) {
                if (intent.id == data.id) {
                  vm.intents.splice(intent_index, 1)
                  return false
                }
              })

              if (vm.allIntents) {
                var findIndex = vm.allIntents.find(function(el) {
                  return el.id == data.id
                })

                if (findIndex > -1) {
                  vm.allIntents.splice(findIndex, 1)
                }
              }
              vm.$store.dispatch('loading')
            })
          }
        })
    },
    addCommentToInbox() {
      let account_packages = this.getPackageType()

      if (
        account_packages.includes('enterprise') ||
        this.$store.state.UnlimitedConversation.includes(this.currentpageid)
      ) {
        this.$store.commit('ADD_EDITTING_INTENT', 'ADD_INTENT')
        this.isShow = true
      } else if (
        (account_packages.includes('business') || account_packages.includes('advanced')) &&
        this.all_count >= this.max_intent
      ) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'reply_comment_you_have_reached_the_limit_for_the_package'
            )}${this.$t('please_contact_us')}</b>`,
            confirmButtonText: this.$t('contact_us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then(result => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else if (this.all_count >= this.max_intent) {
        this.$swal
          .fire({
            html: `<b class="intentmax"> ${this.$t(
              'reply_comment_you_have_reached_the_limit_for_the_package'
            )}${this.$t('upgrade_to_advanced_now')}</b>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then(result => {
            if (result.value) {
              this.$router.push('Upgrade').catch(() => {})
            }
          })
      } else {
        this.$store.commit('ADD_EDITTING_INTENT', 'ADD_INTENT')
        this.isShow = true
      }
    },
    getWelcomeMessage: function(callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }

      vm.welcome_message.message = null
      vm.welcome_message.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        }
      ]
      vm.welcome_message.type = 'message'
      api.getWelcomeMessage(data, function(error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          vm.welcome_message.type = response.data.type
          vm.welcome_message.message = response.data.message_text ? response.data.message_text : ''

          if (
            response.data.message &&
            typeof response.data.message === 'object' &&
            response.data.message.length > 0
          ) {
            $.each(response.data.message, function(index, val) {
              vm.welcome_message.generics[index] = val
            })
          }

          if (
            response.data.message_quickreplies &&
            response.data.message_quickreplies !== '' &&
            response.data.message_quickreplies != null
          ) {
            vm.welcome_message.quick_reply = response.data.message_quickreplies.split(',')
          } else {
            vm.welcome_message.quick_reply = []
          }
        }
        callback()
      })
    },
    expandAll: function() {
      this.intents.forEach((el, index) => {
        this.$set(this.intents[index], 'isShow', true)
      })
      this.$set(this.default_comment_to_inbox, 'isShow', true)
    },
    collapseAll: function() {
      this.intents.forEach((el, index) => {
        this.$set(this.intents[index], 'isShow', false)
      })
      this.$set(this.default_comment_to_inbox, 'isShow', false)
    },
    onUpdateIntent: function(payload) {
      var vm = this
      $.each(vm.intents, function(index, intent) {
        if (intent.id == payload.id) {
          vm.intents[index] = payload
          return false
        }
      })
    },
    clearSearch() {
      const vm = this
      vm.search = ''
      vm.getIntent()
    }
  },
  watch: {
    selectedBot: function(newVal, oldVal) {
      // this.getIntent(function() {})
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.edittingIntent && this.$store.state.edittingIntent.length > 0) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.$store.commit('CLEAR_EDITTING_INTENT')
        next()
      } else {
        next(false)
      }
    } else {
      this.$store.commit('CLEAR_EDITTING_INTENT')
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
.input-icons {
  display: contents;
  i {
    position: absolute;
  }
  .icon-close {
    color: gray;
    padding: 16px;
    margin-left: -40px;
  }
  .icon {
    padding: 16px;
    min-width: 50px;
  }
  input {
    padding-left: 35px !important;
    padding-right: 35px !important;
    width: 100%;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/CommentToInbox.vue